module.exports = __webpack_public_path__ + "static/media/reddit.3e7e6d57.svg";